const VERSION = process.env.NEXT_PUBLIC_BUILD_VERSION ?? 'dev';

export default VERSION;
